import './StripCalendarDates.scss';

const StripCalendarDates = ({dates}) => { 

    /**
     * @param date 
     * @returns class name of date number
     */
     const getDateNumberClassName = (date) => {
        const className = "date__number";
        if(date.carryOver && !date.selected) return className + " number--carry-over";
        if(date.selected) return className + " number--selected";
        if(date.active) return className + " number--active";
        return className;
    }

    return (
        <div className="c-strip-calendar-dates">
            {dates.map((date, index) => {
                return(
                    <div className={`c-date ${date.selected ? 'c-date--selected' : date.today ? 'c-date--today' : ''}`} style={{width: `${(100/dates.length)}%`}} key={index}>
                        <span className={`date__day ${date.selected ? 'day--selected' : ''}`}>{date.name}</span>
                        <span className={getDateNumberClassName(date)}>{date.number}</span>
                    </div>
                )
            })}
        </div>
    )
}

export default StripCalendarDates;